import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { urlFor } from "../../client";
import { Link } from "react-router-dom";

export default function BlogSection({ post }) {
  const {
    title,
    slug,
    mainImage,
    publishedAt,
    description,
    author,
    categories,
  } = post || {};
  return (
    <Link to={`/blog/${slug.current}`} className="flex no-underline flex-col items-start justify-between w-[100%] rounded shadow-[0px_0px_10px_5px_#0000002c]">
      {mainImage && mainImage.asset && (
        <div className="h-[200px] w-full mx-auto">
          <LazyLoadImage
            alt={post?.title}
            effect="blur"
            src={urlFor(mainImage?.asset)?.url()}
            className="Blog__Image"
          />
        </div>
      )}

      <div className="group relative w-full">
      <div className="p-[10px]">
      <p title={title} className=" text-[2.5rem] h-[6rem] sm:text-[2rem] font-bold capitalize leading-[25px]  group-hover:text-gray-600">
          {title && (
            <a
              href={`/blog/${slug.current}`}
              className="text-[#007cba] no-underline"
            >
              {title}
            </a>
          )}
        </p>
        <p title={description} className="!mt-[10px] line-clamp-3 h-[6rem] font-medium  text-[2rem] sm:text-[1.5rem] leading-[25px] text-gray-600">
          {description?.slice(0, 70)} {description.length > 70 && "...."}
        </p>
         
      </div>
          <div className="border-[#0000002c] border-b  w-full " />
        <div className="p-[10px]">
          {publishedAt && (
            <span className="text-gray-500 text-[1.8rem] w-full block sm:text-[1.4rem] items-start leading-[15px]">
              {new Date(publishedAt).toLocaleDateString("en-US", {
                dateStyle: "long",
              })}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}
